import { Card, SimpleGrid, Skeleton, Stack } from '@mantine/core'

export const VlmDeviceCardSkeleton = () => {
  return (
    <Card withBorder>
      <SimpleGrid cols={{ base: 1, sm: 2 }}>
        <Stack gap="sm">
          <Skeleton height={16} width="50%" />
          <Skeleton height={12} width="30%" />
          <Skeleton height={12} width="40%" />
        </Stack>

        <Stack gap="sm">
          <Skeleton height={12} width="30%" />
          <Skeleton height={20} width="40%" radius="xl" />
          <Skeleton height={28} width="35%" radius="sm" />
        </Stack>
      </SimpleGrid>
    </Card>
  )
}
